import { Injectable } from '@angular/core';
import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Router
} from '@angular/router';
import {InternalStorage, UserProfileApi} from '../sdk';

@Injectable()
export class AuthGuard implements CanActivate {
    public authToken;
    private isAuthenticated = false; // Set this value dynamically
    protected prefix: string = '$LoopBackSDK$';

    constructor(
        private router: Router,
        private userProfileApi: UserProfileApi,
        private storage: InternalStorage,
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        this.isAuthenticated = this.userProfileApi.isAuthenticated();
        let userRole = this.storage.get(`${this.prefix}userRole`);

        if (this.isAuthenticated && userRole) {
            return true;
        }
        this.router.navigate(['/sessions/signin']);
        return false;
    }
}
